import Connector from './connector';
import { LocalReportCreationModal as Component } from './LocalReportCreationModal';
import { ConnectorProps } from './LocalReportCreationModal.proptypes';

interface LocalReportCreationModalProps extends Omit<ConnectorProps, 'component'> {}

export const LocalReportCreationModal = (props: LocalReportCreationModalProps) => (
  <Connector {...props} component={Component} />
);
